module.exports = __webpack_public_path__ + "assets/9eee0ac97ad66f661573d42dd0b2b96d.png";